import React, { ReactElement } from 'react';
import { ErrorPage } from '@components';
import { useFormikContext } from 'formik';
import { iInstalmentFormValues } from '@services/InstalmentService';

function InstalmentErrorPage(): ReactElement {
  const { values }: { values: iInstalmentFormValues } = useFormikContext();
  return (
    <>
      <ErrorPage errorMessage={values.submissionError} />
    </>
  );
}

export default InstalmentErrorPage;
